// extracted by mini-css-extract-plugin
export default {"container":"HeaderHome_container__Jgo9S","icon":"HeaderHome_icon__jRNAJ","message":"HeaderHome_message__YkN5L","opacity":"HeaderHome_opacity__5DbVi","hide":"HeaderHome_hide__RW-T6"};